import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import "../../../../util/string";
import { KpiServiceError, KpiServiceErrorType } from "../../../../dashboardCommon/services/kpiServiceError";
import { DateRange } from "./dateRange";
import { OrdersKpiCfg, OrdersKpiCfgService } from "./ordersKpiCfg.service";
import { OrdersKpiService, Range } from "./ordersKpiService";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class PendingOrdersDetailServiceData {
    public link: string;

    constructor(link: string) {
        this.link = link;
    }
}

export abstract class PermPendingOrdersDetailService extends OrdersKpiService<PendingOrdersDetailServiceData> {
    public getClassName() { return "PermPendingOrdersDetailService"; }

    protected abstract getRange(): DateRange;

    constructor(private serviceCfg: OrdersKpiCfgService, private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService, private httpClient: HttpClient, injector: Injector) {
        super(injector);
    }

    protected getDates(): Range {
        return this.getDateRange(this.getRange());
    }

    protected async update(): Promise<PendingOrdersDetailServiceData> {
        if (this.apigeeService.apiToken && this.officeSelectorService.selectedOffice) {
            let result: PendingOrdersDetailServiceData = null;
            try {
                let cfg: OrdersKpiCfg = this.serviceCfg.getCfg();

                let url = cfg.pendingOrders.permDetailEndpointPattern;

                switch (this.getRange()) {
                    case DateRange.Past: {
                        url = url.format("0", "2", this.officeSelectorService.selectedOffice.id);
                        break;
                    }

                    case DateRange.Inmediate: {
                        url = url.format("1", "1", this.officeSelectorService.selectedOffice.id);
                        break;
                    }
                }
                result = new PendingOrdersDetailServiceData(url);
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }
}

@Injectable()
export class PermPastPendingOrdersDetailService extends PermPendingOrdersDetailService {
    constructor(serviceCfg: OrdersKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Past; };
}

@Injectable()
export class PermInmediatePendingOrdersDetailService extends PermPendingOrdersDetailService {
    constructor(serviceCfg: OrdersKpiCfgService, apigeeService: ApigeeService,
        officeSelectorService: OfficeSelectorService, httpClient: HttpClient, injector: Injector) {
        super(serviceCfg, apigeeService, officeSelectorService, httpClient, injector);
    }

    protected getRange(): DateRange { return DateRange.Inmediate; };
}